module.exports = __webpack_public_path__ + "h5/img/bs_11.04c28927.jpeg";